import { flatpagesApi } from '@features/flatpages/api/flatpagesApi'
import {
  DEFAULT_FLATPAGE_SLUG_DATA,
  FLATPAGE_PAGE_META,
  FLATPAGE_SLUG_DATA,
} from '@features/flatpages/constants'
import type { FlatpageKind } from '@features/flatpages/types'
import { getCountryDomain } from '@shared/lib/getCountryDomain'

/**
 * Загружает простую страницу и подготавливает региональные meta-данные.
 *
 * @param kind - вид простой страницы
 * @returns контент, SEO-данные и breadcrumbs страницы
 */
export const useFlatpagePage = async (kind: FlatpageKind) => {
  const { $host } = useNuxtApp()
  const mode = useRuntimeConfig().public.MODE
  const meta = FLATPAGE_PAGE_META[kind]

  const countryDomain = getCountryDomain($host, mode)
  const countrySlugData = countryDomain
    ? FLATPAGE_SLUG_DATA[kind][countryDomain]
    : undefined
  const slugData = countrySlugData ?? DEFAULT_FLATPAGE_SLUG_DATA[kind]

  const { data: page } = await flatpagesApi.getPage({
    city: slugData.city,
    path: meta.path,
  })

  const breadcrumbs = [
    { text: 'Главная', href: '/' },
    { text: meta.breadcrumbText, href: meta.breadcrumbHref },
  ]

  return {
    title: slugData.title,
    description: slugData.description,
    content: computed(() => page.value?.content ?? ''),
    breadcrumbs,
  }
}
